<template>
	<div class="body">
		<div class="body-container">

			<div class="right-content">
				<div class="content-title" v-if="title">
					<img class="title-wing" src="../../assets/icons/title_wing_left.png" />
					<span class="title-text">{{title}}</span>
					<img class="title-wing" src="../../assets/icons/title_wing_right.png" />
				</div>

				<div class="match-ctr">
					<div class="login-ctr" v-if="hasLogin == 2">
						<div class="login-tips">该功能需要登录后才能使用</div>
						<el-button class="to-login" type="primary" icon="el-icon-s-custom"
							@click="clickLogin">点击登录</el-button>
					</div>
					<template v-else-if="hasLogin == 1">
						<div class="match-create-ctr">
							<el-button type="primary" icon="el-icon-plus" size="medium"
								@click="createUserMatch()">新建</el-button>
						</div>
						<el-table border :data="dataList">
							<el-table-column label="名称" align="center" prop="name" min-width="2" />
							<el-table-column label="省直辖市" align="center" prop="province_name" min-width="1" />
							<el-table-column label="行业" align="center" prop="province_name" min-width="1">
								<template v-slot="{ row }">
									<label>{{row.industryClassify.name}}</label>
								</template>
							</el-table-column>
							<el-table-column label="预测年限" align="center" prop="province_name" min-width="1">
								<template v-slot="{ row }">
									<label>{{row.start_year_predict}}-{{row.end_year_predict}}</label>
								</template>
							</el-table-column>
							<el-table-column label="创建日期" align="center" prop="created_at" min-width="1" />
							<el-table-column label="操作" align="center" prop="province_name" min-width="2">
								<template v-slot="{ row }">
									<el-button type="primary" icon="el-icon-reading" size="medium"
										class="el-button--success" @click="clickMatch(row)">查看</el-button>

									<el-button type="primary" icon="el-icon-delete" size="medium"
										class="el-button--danger" @click="clickDel(row)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>

					</template>


				</div>


			</div>
		</div>

		<el-dialog :visible.sync="showMatchDialog" title="新建匹配度分析" align='center'>
			<div class="create-group-ctr">
				<div class="group-row">
					<label>行业</label>
					<el-select class="group-select" v-model="industry_code" placeholder="请选择" :clearable=true
						filterable>
						<el-option v-for="item in industryList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</div>

				<div class="group-row">
					<label>省直辖市</label>
					<el-select class="group-select" v-model="province" placeholder="请选择" :clearable=true filterable>
						<el-option v-for="item in provinceList" :key="item.province_code" :label="item.province_name"
							:value="item.province_code">
						</el-option>
					</el-select>
				</div>

				<div class="group-row">
					<label>年份</label>
					<el-select class="group-select" v-model="year" placeholder="请选择" :clearable=true>
						<el-option v-for="item in matchYearList" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="confirmCreateMatch()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		createMajorMatch,
		getMajorMatchList,
		getJobList,
		delMatch,
		queryCareerList,
		getServiceConfigData,
	} from "@/api/service"

	import {
		getAddrTree,
		exportGroupJobData
	} from "@/api/matrix"

	import {
		isEmpty,
		setLocalData,
		getLocalData
	} from "@/utils/util"

	import {
		useLoginStore
	} from "@/utils/login"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	const DEFAULT_SERVICE_MENU = 'DEFAULT_SERVICE_MENU'

	export default {
		name: "Service",
		data() {
			return {
				name: '',
				province: '',
				provinceList: [],
				showMaterialDialog: false,
				docId: '',
				total: 0,
				materialTotal: 0,
				CustomId: {
					Industry: 999999,
					MajorMatch: 8888881,
					Job: 777777,
					Bi: 666666
				},
				degreeList: null,
				degree: '',
				showMatchDialog: false,
				year: '',
				hasLogin: 3,
				selectJobMap: {},
				defaultMenuPath: '',
				sectorTree: [],
				childIndustryList: [],
				dataList: [],
				sector: '',
				career_code: '',
				careerList: [],
				matchYearList: [],
				industryList: [],
				industry_code: '',
				queryParams: {
					page: 1,
					pageSize: 20
				},
				title: '',
			}
		},

		setup() {
			const loginStore = useLoginStore()

			// 返回 store 到模板中使用
			return {
				loginStore
			}
		},

		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {
				this.requestMajorMatchList();
				this.loadConfig();
			},
			
			requestMajorMatchList(){
				getMajorMatchList(this.buildParams()).then(res => {
					this.hasLogin = res.data.hasLogin;
					if (this.hasLogin == 1) {
						this.dataList = res.data.list;
						this.total = res.data.pageData.totalCount;
						this.title = res.data.title;
						console.log('this.dataList', this.dataList)
					}
				});
			},
			
			loadConfig() {
				getServiceConfigData().then(res => {
					this.provinceList = res.data.tree;
					this.yearList = res.data.yearList;
					this.thirdYearList = res.data.thirdYearList;
					this.industryList = res.data.industryList;
					this.degreeList = res.data.degreeList;
					this.matchYearList = res.data.matchYearList;
					this.sectorTree = res.data.industryTree;
				});
			},
			

			buildParams() {
				this.queryParams['degree'] = this.degree;
				this.queryParams['province_code'] = this.province;
				this.queryParams['industry_code'] = this.industry_code;
				this.queryParams['year_value'] = this.year;

				return this.queryParams;
			},


			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},

			clickCloseDialog() {
				this.showMaterialDialog = false;
			},

			changeProvince(value) {
				let id = this.curMenu.id;

				if (id == this.Channel.Industry) {
					// this.requestThirdIndustryData();
				} else if (id == this.Channel.EduData) {
					// this.requestEduData();
				} else if (this.showMaterialDialog) {
					this.requestMaterialData();
				}
			},

			//-----------match----------	

			createUserMatch() {
				this.year = '';
				this.province = '';
				this.showMatchDialog = true;
			},

			confirmCreateMatch() {
				createMajorMatch(this.buildParams()).then(res => {
					this.showMatchDialog = false;
					this.requestMajorMatchList();
				})
			},

			clickMatch(row) {
				let path = '/data_source?id=' + row.id;
				this.$router.push(path);
			},

			clickDel(row) {
				this.$modal.confirm('确定要删除该条数据吗？').then(() => {
					delMatch({
						'id': row.id
					}).then(res => {
						this.changeLeftTab();
					})
				})
			},

			clickLogin() {
				this.loginStore.openLoginDialog()
			}

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "index.scss";
</style>